import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// config
import { HEADER, NAVBAR } from '../../config';
// components
import DashboardHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
// hooks
import usePage from 'src/hooks/usePage';

// ----------------------------------------------------------------------

type MainStyleProps = {
  collapseClick: boolean;
  alert: string;
};

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})<MainStyleProps>(({ collapseClick, theme, alert }) => ({
  flexGrow: 1,
  // MOBILE_HEIGHT & DASHBOARD_DESKTOP_HEIGHT need to be increased by subscription top Alert component height
  paddingTop: HEADER.MOBILE_HEIGHT + 14 + (alert === 'true' ? 70 : 0),
  paddingBottom: HEADER.MOBILE_HEIGHT,
  paddingLeft: 16,
  paddingRight: 16,
  [theme.breakpoints.up('lg')]: {
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 16 + (alert === 'true' ? 70 : 0),
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const { isOpenAlert } = usePage();

  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
      }}
    >
      <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />

      <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <MainStyle collapseClick={collapseClick} alert={isOpenAlert?.toString()}>
        <Outlet />
      </MainStyle>
    </Box>
  );
}
